// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__B_Gxj","shareTitle":"Footer_shareTitle__2u7IV"};